import React, { useState } from "react";
import { Bar } from "react-chartjs-2";
import FeeTransactions from "../student/tabs/FeeTransactions";

export default function CourseFeeAdvanced({ data, setLoading, getDataList }) {
  const [activeTab, setActiveTab] = useState("overview");
  const getModules = (moduleStr) => {
    try {
      return JSON.parse(moduleStr || "[]");
    } catch (e) {
      return [];
    }
  };

  const courses = data?.course_and_fees || [];

  const totalFees = courses.reduce(
    (sum, c) => sum + Number(c.total_fee || 0) + Number(c.reg_fee || 0),
    0,
  );

  const totalPaid = courses.reduce(
    (sum, c) => sum + Number(c.fees_paid || 0) + Number(c.paid_reg_fee || 0),
    0,
  );

  const totalPending = totalFees - totalPaid;

  const chartData = {
    labels: courses.map((c) => c.course?.title),
    datasets: [
      {
        label: "Total",
        data: courses.map((c) => c.total_fee),
        backgroundColor: "#7c3aed",
      },
      {
        label: "Paid",
        data: courses.map((c) => c.fees_paid),
        backgroundColor: "#22c55e",
      },
    ],
  };

  return (
    <div className="">
      {/* 🔷 SUMMARY */}
      <div className="row g-3 mb-4">
        <div className="col-lg-4 col-md-6">
          <div className="card border-0 shadow-sm h-100">
            <div className="card-body">
              <div className="d-flex justify-content-between">
                <div>
                  <small className="text-muted">Total Fees</small>
                  <h3 className="fw-bold text-primary mb-0">
                    ₹{totalFees.toLocaleString()}
                  </h3>
                </div>

                <div className="avatar avatar-sm bg-label-primary">
                  <i className="ri-money-rupee-circle-line fs-4"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-4 col-md-6">
          <div className="card border-0 shadow-sm h-100">
            <div className="card-body">
              <div className="d-flex justify-content-between">
                <div>
                  <small className="text-muted">Collected</small>
                  <h3 className="fw-bold text-success mb-0">
                    ₹{totalPaid.toLocaleString()}
                  </h3>
                </div>

                <div className="avatar avatar-sm bg-label-success">
                  <i className="ri-checkbox-circle-line fs-4"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-4 col-md-12">
          <div className="card border-0 shadow-sm h-100">
            <div className="card-body">
              <div className="d-flex justify-content-between">
                <div>
                  <small className="text-muted">Outstanding</small>
                  <h3 className="fw-bold text-danger mb-0">
                    ₹{totalPending.toLocaleString()}
                  </h3>
                </div>

                <div className="avatar avatar-sm bg-label-danger">
                  <i className="ri-error-warning-line fs-4"></i>
                </div>
              </div>

              <div className="progress mt-3" style={{ height: 6 }}>
                <div
                  className="progress-bar bg-danger"
                  style={{
                    width: `${(totalPending / totalFees) * 100 || 0}%`,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 🔷 TAB BUTTONS */}
      <div className="card border-0 shadow-sm mb-3">
        <div className="card-body p-2">
          <div className="d-flex flex-wrap gap-2">
            <button
              className={`btn ${
                activeTab === "overview"
                  ? "btn-primary"
                  : "btn-outline-secondary"
              }`}
              onClick={() => setActiveTab("overview")}
            >
              Overview
            </button>

            <button
              className={`btn ${
                activeTab === "transactions"
                  ? "btn-primary"
                  : "btn-outline-secondary"
              }`}
              onClick={() => setActiveTab("transactions")}
            >
              Transactions
            </button>

            <button
              className={`btn ${
                activeTab === "details"
                  ? "btn-primary"
                  : "btn-outline-secondary"
              }`}
              onClick={() => setActiveTab("details")}
            >
              Details
            </button>
          </div>
        </div>
      </div>

      {/* 🔷 TAB CONTENT */}

      {/* ✅ OVERVIEW */}
      {activeTab === "overview" && (
        <>
          <div className="card p-3 mb-3 shadow-sm border-0">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div>
                <h5 className="mb-0 fw-bold">Fee Analytics</h5>

                <small className="text-muted">
                  Course-wise collection performance
                </small>
              </div>
            </div>
            <div style={{ height: 350 }}>
              <Bar
                data={chartData}
                options={{
                  maintainAspectRatio: false,
                  responsive: true,
                  plugins: {
                    legend: { position: "top" },
                  },
                  datasets: {
                    bar: {
                      maxBarThickness: 40,
                    },
                  },
                }}
              />
            </div>
          </div>
        </>
      )}

      {/* ✅ TRANSACTIONS */}
      {activeTab === "transactions" && (
        <>
          <FeeTransactions
            data={data}
            setLoading={setLoading}
            handleFunction={getDataList}
          />

          <div className="card p-3 shadow-sm border-0">
            {/*
          <h5>💳 Transactions</h5>
          <table className="table table-hover align-middle mb-4">
            <thead className="">
              <tr>
                <th>Date</th>
                <th>Receipt</th>
                <th>Amount</th>
                <th>Mode</th>
              </tr>
            </thead>

            <tbody>
              {data?.transactions?.length > 0 ? (
                data.transactions.map((t) => {
                  const modules = getModules(t.module);

                  return (
                    <tr key={t.id}>
                      <td className="fw-semibold">{t.payment_date}</td>

                      <td>
                        <span className="badge bg-label-primary">
                          {t.receipt_no}
                        </span>
                      </td>

                      <td>
                        <div className="fw-bold text-dark">₹{t.amount}</div>

                        <div className="d-flex flex-wrap gap-1 mt-1">
                          {modules.map((m, i) => (
                            <span
                              key={i}
                              className="badge bg-label-secondary"
                              style={{ fontSize: "0.7rem" }}
                            >
                              {m.type}: ₹{m.amount}
                            </span>
                          ))}
                        </div>
                      </td>

                      <td>
                        <span className="badge bg-label-success">
                          {t.payment_method}
                        </span>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="4" className="text-center text-muted py-3">
                    No Transactions Found
                  </td>
                </tr>
              )}
            </tbody>
          </table> */}

            {/* 🔷 EMI SECTION */}
            <div className="d-flex justify-content-between align-items-center mt-4 mb-3">
              <h5 className="mb-0">EMI Schedule</h5>

              <span className="badge bg-label-primary">
                {data?.student_emi?.length || 0} EMI(s)
              </span>
            </div>

            <div className="table-responsive">
              <table className="table table-hover align-middle">
                <thead>
                  <tr>
                    <th>EMI Date</th>
                    <th>Amount</th>
                    <th>Paid</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.student_emi?.length > 0 ? (
                    data.student_emi.map((emi) => (
                      <tr key={emi.id}>
                        <td>{emi.emi_date}</td>
                        <td>₹{emi.emi_amount}</td>
                        <td>₹{emi.paid_amount}</td>
                        <td>
                          <span
                            className={`badge ${
                              emi.emi_payment_status === "Due"
                                ? "bg-danger"
                                : "bg-success"
                            }`}
                          >
                            {emi.emi_payment_status}
                          </span>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center text-muted">
                        No EMI Data
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
      {/* ✅ DETAILS */}
      {activeTab === "details" && (
        <div className="row">
          {courses.map((c) => {
            const total = Number(c.total_fee || 0);
            const paid = Number(c.fees_paid || 0);
            const pending = total - paid;

            const statusText =
              c.status === "1"
                ? "Active"
                : c.status === "2"
                  ? "Inactive"
                  : c.status === "3"
                    ? "Delete"
                    : c.status === "4"
                      ? "Transfer"
                      : c.status === "5"
                        ? "Complete"
                        : "Unknown";

            return (
              <div className="col-md-6" key={c.id}>
                <div
                  className="card border-0 shadow-sm mb-3 h-100"
                  style={{
                    borderRadius: "16px",
                  }}
                >
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-start mb-3">
                      <span>{c.course?.title}</span>

                      <span
                        className={`badge ${
                          c.status === "1"
                            ? "bg-success"
                            : c.status === "2"
                              ? "bg-secondary"
                              : c.status === "3"
                                ? "bg-danger"
                                : c.status === "4"
                                  ? "bg-warning text-dark"
                                  : c.status === "5"
                                    ? "bg-primary"
                                    : "bg-dark"
                        }`}
                      >
                        {statusText}
                      </span>
                    </div>

                    <small className="d-block">
                      <strong>Batch:</strong> {c.batch?.title}
                    </small>

                    <small className="d-block">
                      <strong>Session:</strong> {c.session_year?.session}
                    </small>

                    <p className="mb-1">
                      <strong>Total:</strong> ₹{total}
                    </p>

                    <p className="text-success mb-1">
                      <strong>Paid:</strong> ₹{paid}
                    </p>

                    <p className="text-danger">
                      <strong>Pending:</strong> ₹{pending}
                    </p>

                    <div className="progress" style={{ height: 6 }}>
                      <div
                        className="progress-bar"
                        style={{
                          width: `${(paid / total) * 100 || 0}%`,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
